class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
(() => {
  const hoverDevice = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  function setupHoverMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.cascadeReady) return;
      menu.dataset.cascadeReady = 'true';

      const mainDetails = menu.querySelector('details');
      if (!mainDetails) return;

      const nestedDetails = Array.from(
        menu.querySelectorAll('details[id^="Details-HeaderSubMenu-"]')
      );

      let mainTimer;

      function setOpen(details, open) {
        details.open = open;
        details.querySelector('summary')?.setAttribute(
          'aria-expanded',
          String(open)
        );
      }

      menu.addEventListener('mouseenter', () => {
        if (!hoverDevice.matches) return;
        clearTimeout(mainTimer);

        document.querySelectorAll('header-menu').forEach((other) => {
          if (other === menu || other.contains(document.activeElement)) return;

          other.querySelectorAll('details').forEach((details) => {
            setOpen(details, false);
          });
        });

        setOpen(mainDetails, true);
      });

      menu.addEventListener('mouseleave', () => {
        if (!hoverDevice.matches) return;

        mainTimer = setTimeout(() => {
          if (menu.contains(document.activeElement)) return;
          nestedDetails.forEach((details) => setOpen(details, false));
          setOpen(mainDetails, false);
        }, 200);
      });

      nestedDetails.forEach((details) => {
        const row = details.parentElement;
        let timer;

        row.addEventListener('mouseenter', () => {
          if (!hoverDevice.matches) return;
          clearTimeout(timer);

          nestedDetails.forEach((other) => {
            if (
              other !== details &&
              other.parentElement === details.parentElement &&
              !other.contains(document.activeElement)
            ) {
              setOpen(other, false);
            }
          });

          setOpen(details, true);
        });

        row.addEventListener('mouseleave', () => {
          if (!hoverDevice.matches) return;

          timer = setTimeout(() => {
            if (details.contains(document.activeElement)) return;
            setOpen(details, false);
          }, 200);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHoverMenus);
  } else {
    setupHoverMenus();
  }

  document.addEventListener('shopify:section:load', setupHoverMenus);
})();
